import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 20.04 23.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.04 23.8\" id=\"icon-info\"><g id=\"icon-info_Layer_2\" data-name=\"Layer 2\"><g id=\"icon-info_Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M20,7.44a5.36,5.36,0,0,0-1.24-2.8l-3.2-3.32A5,5,0,0,0,12.88,0L1.79,0A1.83,1.83,0,0,0,0,1.86V21.94A1.83,1.83,0,0,0,1.79,23.8H18.25A1.83,1.83,0,0,0,20,21.94ZM8.77,6.12h2.5v2.5H8.77Zm3.76,12.53h-5V17.4H8.77v-5H7.51V11.13h3.76V17.4h1.25Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol